import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface SimulatedLoadingProps {
  fallback: React.ReactNode;
  children: React.ReactNode;
  delay?: number;
}

export function SimulatedLoading({ fallback, children, delay = 500 }: SimulatedLoadingProps) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <AnimatePresence mode="wait">
      {loading ? (
        <motion.div
          key="fallback"
          initial={{ opacity: 0.6 }}
          animate={{ opacity: [0.6, 1, 0.6] }}
          exit={{ opacity: 0, y: -10, transition: { duration: 0.25 } }}
          transition={{
            opacity: { repeat: Infinity, duration: 1.5, ease: "easeInOut" }
          }}
          className="w-full"
        >
          {fallback}
        </motion.div>
      ) : (
        <motion.div
          key="content"
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          className="w-full"
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default SimulatedLoading;
